/* Studio Imola · core interactions (no dependencies). */
(function () {
var root = document.documentElement;
var noHover = matchMedia('(hover: none)').matches;
var store = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
var sw = document.querySelector('.six-switch');
function setDesign(d) {
root.dataset.design = d;
document.querySelectorAll('.six-switch [data-d]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.d === d); });
store.set('si-design', d);
document.dispatchEvent(new CustomEvent('six:design', { detail: { design: d } }));
}
if (sw && document.querySelector('.six-page')) {
sw.hidden = false;
sw.querySelectorAll('[data-d]').forEach(function (b) { b.addEventListener('click', function () { setDesign(b.dataset.d); }); });
setDesign(root.dataset.design || 'dark');
}
var burger = document.querySelector('[data-six-burger]'), drawer = document.querySelector('[data-six-drawer]');
if (burger && drawer) burger.addEventListener('click', function () {
var open = drawer.hidden; drawer.hidden = !open; burger.setAttribute('aria-expanded', open);
});
document.querySelectorAll('[data-six-cluster]').forEach(function (cluster) {
if (!noHover) return;
var hint = cluster.closest('.hero') && cluster.closest('.hero').querySelector('[data-hint]');
if (hint && hint.dataset.touch) hint.textContent = hint.dataset.touch;
cluster.addEventListener('click', function (e) {
var a = e.target.closest('.item'); if (!a) return;
if (!a.classList.contains('active')) {
e.preventDefault();
cluster.querySelectorAll('.item.active').forEach(function (x) { x.classList.remove('active'); });
a.classList.add('active');
}
});
document.addEventListener('click', function (e) { if (!e.target.closest('.item')) cluster.querySelectorAll('.item.active').forEach(function (x) { x.classList.remove('active'); }); });
});
var toastEl = document.querySelector('.six-toast'), tt;
function toast(msg) {
if (!toastEl) return; toastEl.textContent = msg; toastEl.classList.add('show');
clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
}
function refreshCount() {
return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
.then(function (r) { return r.json(); })
.then(function (c) { document.querySelectorAll('[data-six-count]').forEach(function (el) { el.textContent = c.item_count; }); })
.catch(function () {});
}
window.SixCart = { refresh: refreshCount, toast: toast };
var pdp = document.querySelector('[data-six-product]');
if (pdp) {
var variants = JSON.parse((pdp.querySelector('[data-six-variants]') || {}).textContent || '[]');
var moneyFormat = pdp.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
var form = pdp.querySelector('[data-six-form]');
var idInput = pdp.querySelector('[data-variant-input]');
var priceEl = pdp.querySelector('[data-price]');
var addBtn = pdp.querySelector('[data-add]');
var colourName = pdp.querySelector('[data-colour-name]');
var selected = [];
pdp.querySelectorAll('[data-option-index]').forEach(function (g) {
var on = g.querySelector('[aria-pressed="true"]'); selected[+g.dataset.optionIndex] = on ? on.dataset.value : null;
});
var money = function (cents) {
var n = (cents / 100).toFixed(2), parts = n.split('.');
var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
if (k === 'amount_with_comma_separator') return withComma;
if (k === 'amount_no_decimals') return Math.round(cents / 100);
if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
});
};
var findVariant = function () {
return variants.find(function (v) { return v.options.every(function (o, i) { return selected[i] == null || o === selected[i]; }); });
};
var update = function () {
var v = findVariant();
if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = pdp.dataset.unavailable || 'Unavailable'; } return; }
if (idInput) idInput.value = v.id;
if (priceEl) priceEl.textContent = money(v.price);
if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? (pdp.dataset.addLabel || 'Add to bag') : (pdp.dataset.soldOut || 'Sold out'); }
if (history.replaceState && v.id) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
};
pdp.querySelectorAll('[data-option-index]').forEach(function (g) {
var idx = +g.dataset.optionIndex;
g.addEventListener('click', function (e) {
var b = e.target.closest('[data-value]'); if (!b) return;
g.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
selected[idx] = b.dataset.value;
if (g.dataset.colour === 'true') {
if (colourName) colourName.textContent = b.dataset.value;
document.dispatchEvent(new CustomEvent('six:colour', { detail: { name: b.dataset.value, hex: b.dataset.hex } }));
var img = pdp.querySelector('[data-gallery] [data-colour="' + b.dataset.value.toLowerCase() + '"] img');
var fb = pdp.querySelector('[data-fallback] img');
if (img && fb) { fb.src = img.currentSrc || img.src; fb.srcset = img.srcset || ''; }
}
update();
});
});
if (form) form.addEventListener('submit', function (e) {
e.preventDefault();
if (addBtn) addBtn.disabled = true;
fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form), credentials: 'same-origin'
}).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
.then(function (res) {
if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to bag');
var opts = selected.filter(Boolean).join(', ');
toast((pdp.dataset.addedLabel || 'Added to bag') + ': ' + pdp.dataset.title + (opts ? ', ' + opts : ''));
return refreshCount();
})
.catch(function (err) { toast(err.message); })
.then(function () { update(); });
});
var gal = pdp.querySelector('[data-gallery]');
if (gal) {
var tabs = pdp.querySelectorAll('[data-filter]');
tabs.forEach(function (t) {
t.addEventListener('click', function () {
tabs.forEach(function (x) { x.setAttribute('aria-pressed', x === t); });
var f = t.dataset.filter;
gal.querySelectorAll('.tile').forEach(function (tile) { tile.hidden = !(f === 'all' || tile.dataset.type === f); });
});
});
gal.addEventListener('click', function (e) {
var tile = e.target.closest('.tile.colour'); if (!tile) return;
var btn = pdp.querySelector('[data-colour="true"] [data-value="' + tile.dataset.colourName + '"]');
if (btn) { btn.click(); window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
});
}
}
})();